import {DomainEvent} from './DomainEvent';
import {CompetitionSeason} from '../resources/CompetitionSeason';

export class CompetitionSeasonUpdated extends DomainEvent<CompetitionSeason> {}
